import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Link } from 'react-router';
import { filter } from 'lodash';
import { Accordion, AccordionItem } from 'react-sanfona';
import { urls } from 'helpers/url';
import PhoneLink from 'components/PhoneLink';
import { getWorkroomFilteredByIds } from '../../../../../../../reducers';
import { queryParamStringsToIntArray } from '../../../../../../../utils/validationUtils';
import { formatTime } from '../../../../../../../utils/dateUtils';
import S from 'styles/table.scss';
import reportStyle from 'styles.scss';
import ReleaseMerchandise from '../../../components/ReleaseMerchandise';

const InstallWorkorderTable = ({ workrooms, report: { data } }) => {
  const resultCount = data.length;

  const getWorkroomCount = filteredResults => filteredResults.length;

  const filterByWorkroom = workroom => filter(data, { workroom_name: workroom });

  const sortWorkroomsWithCount = workroomsWithCount =>
    workroomsWithCount.sort((a, b) => b.resultCount - a.resultCount);

  const sortWorkroomsByCount = () => {
    const workroomsWithCount = [];

    workrooms.forEach((w) => {
      const alteredWorkroom = {
        name: w.name,
        resultCount: filterByWorkroom(w.name).length,
      };
      workroomsWithCount.push(alteredWorkroom);
    });

    return sortWorkroomsWithCount(workroomsWithCount);
  };

  const renderNoWorkroomResults = workroom =>
    <div className={reportStyle.noWorkroomResults}>
      {`No results for the ${workroom} workroom`}
    </div>;

  const renderTable = results =>
    <table className={`${S.cardTable} ${reportStyle.table}`} cellSpacing="0">
      <thead>
        <tr className={S.headerRow}>
          <th className={S.column}>PO #</th>
          <th className={S.column}>Customer Name</th>
          <th className={S.column}>Customer Phone #</th>
          <th className={S.column}>Customer Address</th>
          <th className={S.column}>Surface Type</th>
          <th className={S.column}>Net Sq Ft</th>
          <th className={S.column}>Arrival Window</th>
          <th className={S.column}>Assignee</th>
          <th className={S.column}>Store #</th>
          <th className={S.column}>Store Phone #</th>
          <th className={S.column}>Release</th>
        </tr>
      </thead>
      <tbody>
        {results.map(appt =>
          <tr key={appt.id} className={S.contentRow}>
            <td className={S.column}>
              {appt.phase.original_po || 'N/A'}
            </td>
            <td className={S.column}>
              <Link
                to={urls.phaseWarehouseMaterials(appt.phase.id)}
                className={reportStyle.link}
                target="_blank"
              >
                {appt.phase.customer_name || 'N/A'}
              </Link>
            </td>
            <td className={S.column}>
              {appt.phase.phone_number ? (
                <PhoneLink number={appt.phase.phone_number} />
              ) : ('N/A')}
            </td>
            <td className={S.column}>{
              `${appt.phase.street_address || ''} 
              ${appt.phase.city || ''} ${appt.phase.state || ''} 
              ${appt.phase.zip_code || ''}`
            }</td>
            <td className={S.column}>
              {appt.phase.surface_type || 'N/A'}
            </td>
            <td className={S.column}>
              {appt.phase.net_square_footage || 'N/A'}
            </td>
            <td className={S.column}>
              <div>{moment(appt.start_date).format('MM/DD/YYYY')}</div>
              {formatTime(appt.arrival_start_time)} - {formatTime(appt.arrival_end_time)}
            </td>
            <td className={S.column}>{appt.assignee.name}</td>
            <td className={S.column}>
              <Link
                to={urls.store(appt.store)}
                className={reportStyle.link}
                target="_blank"
              >
                {appt.store.number}
              </Link>
            </td>
            <td className={S.column}>
              {appt.store.phone_number ? (
                <PhoneLink number={appt.store.phone_number} />
              ) : ('N/A')}
            </td>
            <td className={S.column}>
              <ReleaseMerchandise appt={appt} />
            </td>
          </tr>,
        )}
      </tbody>
    </table>;

  const renderTablesByWorkroom = () => {
    const sortedWorkrooms = sortWorkroomsByCount(workrooms);
    const tables = sortedWorkrooms.map((w) => {
      const workroom = w.name;
      const workroomResults = filterByWorkroom(workroom) || [];
      const workroomCount = getWorkroomCount(workroomResults);
      return (
        <AccordionItem
          titleClassName={reportStyle.workroomHeader}
          expandedClassName={reportStyle.expandedResults}
          title={`${workroom} (${workroomCount})`}
          key={workroom}
          expanded={false}
        >
          {workroomResults.length > 0 ? renderTable(workroomResults)
            : renderNoWorkroomResults(workroom)}
        </AccordionItem>
      );
    });
    return (<Accordion allowMultiple>
      {tables}
    </Accordion>);
  };

  const renderView = () => {
    if (resultCount) return renderTablesByWorkroom();
    return null;
  };

  return renderView();
};

InstallWorkorderTable.propTypes = {
  report: PropTypes.shape({
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    data: PropTypes.array,
  }),
};

export default connect((state, ownProps) => {
  const workrooms = queryParamStringsToIntArray(ownProps.workrooms || []);
  return ({
    workrooms: getWorkroomFilteredByIds(state)(workrooms || []),
    report: state.reports.installWorkorder,
  });
})(InstallWorkorderTable);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/installWorkorderReport/components/InstallWorkorderTable/index.jsx